import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'ENVIRONMENTS_PAGE.DUPLICATE_NAME_KEY',
    stateKey: 'name',
  },
];

export default fields;
